const devolucion_proveedor = state => state.devolucion_proveedor;

export default {
  devolucion_proveedor,
};